import { useEffect } from "react";
import { TokenManager, isAppWebView } from "utils/api";

const useNativeTokenSync = () => {
    useEffect(() => {
        if (!isAppWebView()) return;

        // 1. Native → FE access token restore callback
        window.onAuthToken = (accessToken) => {
            if (accessToken) {
                TokenManager.saveAccessToken(accessToken);
            }
        };

        // 2. onAuthSessionRecovered is registered dynamically by requestRecovery() in api.js
        //    We only set up the onAuthToken listener here.

        return () => {
            delete window.onAuthToken;
        };
    }, []);
};

export default useNativeTokenSync;
